<div
  class="input-group mbs-smart-search"
  [ngClass]="size ? 'input-group-' + size : ''">
  <div
    #formControlRef
    [class]="'form-control row g-0 ' + getValidationStateClasses()"
    [ngClass]="[isFocus ? '-focus' : '', size ? 'form-control-' + size : '', disabled ? 'disabled' : '']">
    <div
      ngbDropdown
      class="col"
      [autoClose]="'outside'"
      [container]="container"
      [placement]="placementNgbDropdown">
      <div
        #smartSearch
        ngbDropdownToggle
        class="-no-arrow"
        contenteditable="true"
        id="smart-search"
        spellcheck="false"
        [class]="elementSelectors.css.input"
        [ngClass]="size ? 'mbs-smart-search_content-' + size : ''"
        (blur)="handleBlur()"
        (drop)="handleDrop($event)"></div>

      <div
        [ngClass]="[
          'text-gray-500',
          elementSelectors.css.placeholder,
          size ? elementSelectors.css.placeholder + '-' + size : '',
          smartSearch.firstChild ? 'd-none' : ''
        ]"
        (click)="placeholderClick($event)">
        {{ placeholder }}
      </div>

      <div
        ngbDropdownMenu
        aria-labelledby="smart-search"
        class="mbs-smart-search_dropdown-menu"
        [class.show]="(showDropdown$ | async) && isOpenedDropdownMenu(DropdownMenuType.Base)"
        [dropdownRef]="DropdownMenuType.Base"
        [ngStyle]="dropdownHeight ? { 'overflow-y': 'auto', 'overflow-x': 'hidden', maxHeight: dropdownHeight + 'px' } : null"
        (mouseleave)="selectedItemIndex = -1">
        @for (item of items; track item) {
          <button
            class="dropdown-item mbs-smart-search_dropdown-item"
            [class.active]="selectedItemIndex === $index"
            (mousedown)="handleClickSelectedValue(item)"
            (mouseenter)="selectedItemIndex = $index || 0">
            <ng-container
              [ngTemplateOutlet]="item.template ? item.template : defaultTemplate"
              [ngTemplateOutletContext]="{ $implicit: item, formatter: item.formatter }" />

            <ng-template
              #defaultTemplate
              let-formatter="formatter">
              <ngb-highlight
                [result]="formatter(item)"
                [term]="state.leftCaretClearValue">
                {{ formatter(item) }}
              </ngb-highlight>
            </ng-template>
          </button>
        }
      </div>
    </div>

    <div class="col-auto d-flex align-items-center justify-content-center">
      @if ((loading$ | async) || (searching$ | async)) {
        <div class="px-2">
          <span class="loader"></span>
        </div>
      }

      @if (!(loading$ | async) && !(searching$ | async) && searchContent.length > 0) {
        <mbs-button
          [customClasses]="'form-control_clear-btn' + (size ? ' -' + size : '')"
          [disabled]="disabled"
          [icon]="'ico ico-Delete-text mr-0 px-2'"
          [isCtrl]="true"
          [ngClass]="size ? '-' + size : ''"
          [title]="'Clear'"
          [type]="'dark'"
          [size]="size"
          (click)="handleClear()" />
      }
    </div>

    <div
      ngbDropdown
      class="col-auto"
      [autoClose]="false"
      [container]="'body'"
      [placement]="placementNgbDropdownForm">
      @if (placementNgbDropdownForm === 'bottom-left' && searchFormTemplate) {
        <div
          ngbDropdownAnchor
          [style]="{
            position: 'absolute',
            top: '0',
            left: ngbDropdownAnchorLeftStyle,
            right: '0',
            bottom: '0',
            opacity: '0',
            pointerEvents: 'none'
          }"></div>
      }

      @if (searchFormTemplate) {
        <button
          #toggleButtonRef
          ngbDropdownToggle
          class="ctrl ctrl-dark h-100 d-flex align-items-center px-2"></button>

        <div
          ngbDropdownMenu
          class="mbs-smart-search_dropdown"
          [dropdownRef]="DropdownMenuType.Form">
          <ng-container [ngTemplateOutlet]="searchFormTemplate" />
        </div>
      }
    </div>
  </div>

  <div class="input-group-append">
    <mbs-button
      [customClasses]="getValidationStateClasses()"
      [disabled]="disabled"
      [size]="size"
      [type]="'secondary'"
      (click)="handleUpdateModel()">
      <span [ngClass]="searchIcon"></span>
    </mbs-button>
  </div>
</div>
